export default "__VITE_ASSET__PnDxijMw__"